const state = {
  activeIndex: 0,
  promotionActiveIndex: 0,
  officialAccountActiveIndex: 0,
  personalActiveIndex: undefined,
  officialItemActiveIndex: 0,
  isGoOfficial:0,
  kfcAccountActiveIndex: 0,
  movieShowDialog: false,
  slideActive: 0,
  activeIndexMini: 0,
  selectItem: 0,
  isOpenDouyin: true,
  isOpenKuaiShou:true,
}

const mutations = {
  SET_ACTIVE_slideActive: (state, activeIndex) => {
    state.slideActive = activeIndex
  },
  SET_ACTIVE_INDEX: (state, activeIndex) => {
   state.activeIndex = activeIndex
 },
  SET_PROMOTION_ACTIVE_INDEX:(state,activeIndex)=>{
   state.promotionActiveIndex = activeIndex
 },
 SET_OFFICIAL_ACCOUNT_ACTIVE_INDEX:(state,activeIndex)=>{
   state.officialAccountActiveIndex = activeIndex
 },
 SET_PERSONAL_ACTIVE_INDEX:(state,activeIndex)=>{
   state.personalActiveIndex = activeIndex
 },
 SET_OFFICIAL_ITEM_ACTIVE_INDEX:(state,activeIndex)=>{
   state.officialItemActiveIndex = activeIndex
 },
  SET_IS_GO_OFFICIAL:(state,isGoOfficial)=>{
   state.isGoOfficial = isGoOfficial
 },
  SET_KFC_ACCOUNT_ACTIVE_INDEX:(state,activeIndex)=>{
    state.kfcAccountActiveIndex = activeIndex
  },
  SET_MOVIE_SHOW_DIALOG(state,movieShowDialog){
    state.movieShowDialog = movieShowDialog
  },
  SET_ACTIVE_INDEX_MINI(state,data){
    state.activeIndexMini = data
  },
  SET_SELECT_ITEM(state,data){
    state.selectItem = data
  },
  SET_ISOPEN_DOUYIN(state,data){
    state.isOpenDouyin = data
  },
  SET_ISOPEN_KUAISHOU(state,data){
    state.isOpenKuaiShou = data
  },
}

const actions = {
  changeActiveIndex({ commit }, activeIndex) {
    commit('SET_ACTIVE_INDEX', activeIndex)
  },
  changePromotionActiveIndex({ commit }, activeIndex) {
    commit('SET_PROMOTION_ACTIVE_INDEX', activeIndex)
  },
  changeOfficialAccountActiveIndex({ commit }, activeIndex) {
    commit('SET_OFFICIAL_ACCOUNT_ACTIVE_INDEX', activeIndex)
  },
  changePersonalActiveIndex({ commit }, activeIndex) {
    commit('SET_PERSONAL_ACTIVE_INDEX', activeIndex)
  },
  changeOfficialItemActiveIndex({ commit }, activeIndex) {
    commit('SET_OFFICIAL_ITEM_ACTIVE_INDEX', activeIndex)
  },
  changeIsGoOfficial({commit},isGoOfficial){
    commit('SET_IS_GO_OFFICIAL', isGoOfficial)
  },
  changeKfcAccountActiveIndex({ commit }, activeIndex) {
    commit('SET_KFC_ACCOUNT_ACTIVE_INDEX', activeIndex)
  },
  changeMovieShowDialog({ commit }, movieShowDialog) {
    commit('SET_MOVIE_SHOW_DIALOG', movieShowDialog)
  },
  changeActiveIndexMini({commit},activeIndexMini){
    commit('SET_ACTIVE_INDEX_MINI', activeIndexMini)
  },
  changeSelectItem({commit},selectItem){
    commit('SET_SELECT_ITEM', selectItem)
  },
  changeIsOpenDouyin({commit},isOpenDouyin){
    commit('SET_ISOPEN_DOUYIN', isOpenDouyin)
  }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/nav.js